import { HeightUnit, WeightUnit } from "@/Common/Utilities/Units/Units";
import { IQuebecObstetricalFileFormPage } from "../IQuebecObstetricalFileFormPage";
import { Signature } from "../Signature";
import { PhysicalExam } from "./PhysicalExam";
import { RiskFactorAndTreatment } from "./RiskFactorAndTreatment";

class QuebecObstetricalFileFormPageTwo implements IQuebecObstetricalFileFormPage {
    public Summary: string;
    public Signature: Signature;
    public IsNeonatalBloodUrineInformationShared: boolean;
    public VitalSignEmrTemplateId: string;
    public WeightUnit: WeightUnit;
    public HeightUnit: HeightUnit;
    public PhysicalExam: PhysicalExam;
    public RiskFactorAndTreatment: RiskFactorAndTreatment;
    public PreviousHeight: number;

    constructor(fields?: Partial<QuebecObstetricalFileFormPageTwo>) {
        Object.assign(this, fields);

        this.PhysicalExam = new PhysicalExam(fields?.PhysicalExam);
        this.RiskFactorAndTreatment = new RiskFactorAndTreatment(fields?.RiskFactorAndTreatment);
        this.Signature = new Signature(fields?.Signature);
        this.WeightUnit = fields?.WeightUnit ?? WeightUnit.Kilogram;
        this.HeightUnit = fields?.HeightUnit ?? HeightUnit.Meter;
    }
}

export { QuebecObstetricalFileFormPageTwo };
